import { Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { SlideY } from '@shared/animations';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss', '../shared.scss'],
    animations: [SlideY],
    imports: [ReactiveFormsModule, ErrorComponent],
})
export class TextareaComponent {
    readonly label = input<string | null>(null);
    readonly ariaLabel = input<string>();
    readonly placeholder = input<string>();
    readonly control = input.required<FormControl<string>>();
    readonly identifier = input.required<string>();
    readonly testId = input.required<string>();
    readonly srOnly = input<string>();

    readonly isRequired = computed(() => this.control().hasValidator(Validators.required));
}
